export default {
  notificationList: {
    method: 'post',
    url: '/admincp/notification/list'
  },
  notificationChangeRead: {
    method: 'put',
    url: '/admincp/notification'
  },
  notificationClearAll: {
    method: 'put',
    url: '/admincp/notification/clear-all'
  }
}
